export default __webpack_public_path__ + "static/media/thumbnail.68c32e00.png";